<style>
    /*task[1872]*/
    span[name=nmcargos]:hover {
        background-color: #ffd800;
        font-weight: bold;
    }

    span[name=nmescolas]:hover {
        background-color: #ffd800;
        font-weight: bold;
    }
</style>
<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Relatórios / Colaboradores</li>
                        </ul>
                    </section>
                    <section class="col-sm-6" v-canaccess="'/inativartodoscolaboradores'">
                        <br />
                        <!-- <button type="button" class="btn-large-40 btn-red uppercase float-right" @click="openInativar()">Inativar colaboradores</button>-->
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Relatórios / Colaboradores</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <br />
                                    <!--<label class="text-center">Situação</label>-->
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="1" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Candidato</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="2" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Disponível</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.situacaoJobsId" value="3" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Colaborador</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <br />
                                    <label class="text-center">Sexo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="chkSexo" v-model="filter.sexo" value="" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="chkSexo" v-model="filter.sexo" value="F" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Feminino</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="chkSexo" v-model="filter.sexo" value="M" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Masculino</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cargoId">Cargo</label>
                                    <select v-select="{ dataitem: 'Cargo', default: 'Todos', filters: { attributeBehavior: 'CargoHierarquiaEspecificos' } }" multiple v-model="filter.cargoIds" class="form-control" name="cargoId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="escolaId">Escola</label>
                                    <select v-select="{ dataitem: 'Escola', default: 'Todos', filters: { attributeBehavior: 'escolaColaborador' } }" multiple v-model="filter.escolaIds" class="form-control" name="escolaId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="dataIni">Período da Contratação</label>
                                    <input type="text" name="DtContratacaoStart" value="" id="DtContratacaoStart" placeholder="De" class="form-control" v-datepicker v-model="filter.DtContratacaoStart" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label>&nbsp;</label>
                                    <input type="text" name="DtContratacaoEnd" value="" id="DtContratacaoEnd" placeholder="Até" class="form-control" v-datepicker v-model="filter.DtContratacaoEnd" />
                                </div>
                            </div>

                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                            <!--<button type="button" v-canaccess="'/buscacolaboradores'" style="margin-left: 5px" class="btn-large-40 btn-red uppercase" @click="buscaAvancadaToggle()">Busca Avançada</button>-->

                            <br />
                            <br />

                        </form>
                    </div>

                    <div v-if="filtro">
                        <div class="table-responsive standard-table header-cinza">
                            <table>
                                <thead>
                                    <tr>
                                        <th title="E-mail">E-mail <i @click="executeOrderBy('Email')" class="fa fa-sort"></i></th>
                                        <th title="CPF">CPF <i @click="executeOrderBy('cpf')" class="fa fa-sort"></i></th>
                                        <th title="Nome">Nome <i @click="executeOrderBy('NmCompleto')" class="fa fa-sort"></i></th>
                                        <!-- <th title="Data de Nascimento">Nasc. <i @click="executeOrderBy('DtNascimento')" class="fa fa-sort"></i></th>-->
                                        <th title="Escola">Escola </th>
                                        <th>Cargo</th>
                                        <th title="Situação">Situação <i @click="executeOrderBy('situacaoJobs')" class="fa fa-sort"></i></th>
                                        <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                        <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 15ch; overflow: hidden;">
                                            {{ item.email }}
                                        </td>
                                        <td>{{ item.cpf }}</td>
                                        <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 15ch; overflow: hidden;">{{ item.nmCompleto }}</td>
                                        <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 30ch; overflow: hidden;">
                                            <span v-for="item2 in item.collectionColaboradorEscolaAtiva" @mouseover="colaboradorIdHover = item2.colaboradorId; escolaIdHover = item2.escolaId" @mouseleave="escolaIdHover = 0" v-bind:key="item2.escolaId" name="nmescolas">
                                                {{ item2.escola.nomeEscola }}<br />
                                            </span>
                                        </td>
                                        <td>
                                            <span v-for="item3 in item.collectionColaboradorEscolaAtiva">
                                                <span v-for="item4 in item3.collectionColaboradorEscolaCargo" v-bind:key="item3.cargoId" name="nmcargos" :class="{destaca : colaboradorIdHover == item4.colaboradorId && escolaIdHover == item4.escolaId }">
                                                    {{ item4.cargo.dsCargo }}<br />
                                                </span>
                                            </span>
                                        </td>
                                        <!--<td>{{ item.dtNascimento }}</td>-->
                                        <td>{{ item.situacaoJobs.nome }}</td>

                                        <td class="text-center" width="120">

                                            <!--<button v-if="item.podeAlterarSenha" type="button" class="btn btn-sm btn-secondary" v-b-tooltip title="Alterar Senha" v-canaccess="'/colaborador/senha'" @click="openSenha({ colaboradorId: item.colaboradorId })">
                                                <i class="fa fa-lock"></i>
                                            </button>

                                            <button type="button" class="btn btn-sm btn-primary" v-if="item.ehDisponivel ? ehAdministracaoNacional : true" v-b-tooltip title="Editar" v-canaccess="'/colaborador/edit'" @click="openEdit({ colaboradorId: item.colaboradorId })">
                                                    <i class="fa fa-pencil"></i>
                                                </button>-->
                                            <a v-bind:href="'/colaborador/edit/'+item.colaboradorId" class="btn btn-sm btn-primary" v-if="item.ehDisponivel ? ehAdministracaoNacional : true" v-b-tooltip title="Editar" v-canaccess="'/colaborador/edit'"><i class="fa fa-pencil"></i></a>
                                            <!--<button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes" v-canaccess="'/colaborador/details'" @click="openDetails({ colaboradorId: item.colaboradorId })">
                                                <i class="fa fa-search"></i>
                                            </button>-->
                                            <a v-bind:href="'/colaborador/details/'+item.colaboradorId" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes" v-canaccess="'/colaborador/details'"><i class="fa fa-search"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="7" style="font-weight:bold;text-align:right">Total de registros: {{result.total}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                        <div class="card-block no-padding">
                            <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                        </div>
                        <button class="btn-large-40 btn-red uppercase pull-left btn-header" @click="onExportFilters()">Exportar consulta em Excel</button>
                        <button class="btn-large-40 btn-red uppercase pull-left btn-header" @click="onExportFiltersAnalitico()">Exportar em Excel (Análitico)</button>
                        <button class="btn-large-40 btn-red uppercase pull-left btn-header" @click="onExportPdf()">Exportar em PDF</button>
                    </div>
                    <div>
                        <h2 class="text-center" v-if="!filtro">Faça uma busca para listar os colaboradores</h2>
                    </div>
                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogCreate" :hide-footer="true" title="Novo Candidato">
            <form-create v-if="dialogCreate" @on-saved="onSaved" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogSenha" :hide-footer="true" title="Alterar Senha">
            <form-senha v-if="dialogSenha" :colaborador-id="colaboradorId" @on-saved="hideAll()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogInativar" :hide-footer="true" title="Inativar Colaboradores">
            <form-inativar v-if="dialogInativar" @on-saved="hideAll()" @on-back="hideAll()" />
        </b-modal>


    </main>

</template>

<script>

    import auth from '@/common/auth'
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    //import formCreate from './form-create'
    //import formSenha from './form-senha'
    //import formInativar from './form-inativar'

    export default {
        name: 'relatorios',
        mixins: [base],
        //components: { formCreate, formSenha, formInativar },
        data() {

            return {

                escolaLogadaId: 0,
                ehAdministracaoNacional: 0,

                resources: {
                    filter: 'colaborador',
                },

                dialogCreate: false,
                dialogInativar: false,
                dialogEdit: false,
                dialogSenha: false,
                dialogDetails: false,
                buscaAvancada: false,
                filtro: false,
                model: {},
                municipioPorEstado: true,
                colaboradorId: 0,
                escolaIdHover: 0,
                colaboradorIdHover: 0,
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    attributeBehavior: "ListagemColaboradoresCandidatos",
                    situacaoJobsId: "",
                    regiaoId: "",
                    estadoId: "",
                    cargoId: "",
                    escolaId: "",
                    mesoRegiaoId: "",
                    municipioId: "",
                    microRegiaoId: "",
                    nanoRegiaoId: "",
                    sexo: "",
                    DtContratacaoStart: "",
                    DtContratacaoEnd: "",
                    cargoIds: [],
                    escolaIds: []

                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            onExportFiltersAnalitico: 
                function () {
                    new Api('colaborador/ExportRelatorioAnalitico').export(
                        this.filter
                    ).then(data => {
                        var blob = new Blob([data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });

                        var _a = document.createElement("a");
                        document.body.appendChild(_a);
                        _a.style.visibility = 'hidden';
                        _a.target = "_blank";
                        _a.href = window.URL.createObjectURL(blob);
                        _a.download = "exportacao-relatorio-colaboradores-analitico.xlsx"
                        _a.click();
                        _a.remove();

                    });
                },
            onExportFilters: function () {
                new Api('colaborador/exportRelatorio').export(
                    this.filter
                ).then(data => {
                    var blob = new Blob([data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    var _a = document.createElement("a");
                    document.body.appendChild(_a);
                    _a.style.visibility = 'hidden';
                    _a.target = "_blank";
                    _a.href = window.URL.createObjectURL(blob);
                    _a.download = "exportacao-relatorio-colaboradores.xlsx"
                    _a.click();
                    _a.remove();

                });
            },

            onExportPdf: function () {
                //alert('Gerar arquivo pdf.');
                new Api('colaborador/ExportPdf').export(
                    this.filter
                ).then(data => {
                    var blob = new Blob([data], {
                        type: 'application/pdf'
                    });

                    var _a = document.createElement("a");
                    document.body.appendChild(_a);
                    _a.style.visibility = 'hidden';
                    _a.target = "_blank";
                    _a.href = window.URL.createObjectURL(blob);
                    //_a.download = "exportacao-relatorio-colaboradores.xlsx"
                    _a.click();
                    _a.remove();

                });
            },

            trocandoEstado: function () {
                this.filter.municipioId = "";
                this.municipioPorEstado = true;
                setTimeout(() => { this.municipioPorEstado = false; }, 1000)
            },

            openEdit: function (model) {
                this.$router.push({ path: '/colaborador/edit/' + model.colaboradorId });
            },
            openInativar: function () {
                this.dialogInativar = true;
            },
            openSenha: function (model) {
                this.colaboradorId = model.colaboradorId;
                this.dialogSenha = true;
            },
            openDetails: function (model) {
                this.$router.push({ path: '/colaborador/details/' + model.colaboradorId });
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function (data) {
                this.hideAll();
                this.openEdit(data.data)
            },
            hideAll: function () {
                this.dialogInativar = false;
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogSenha = false;
            },

            buscaAvancadaToggle: function () {
                this.buscaAvancada = !this.buscaAvancada;
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.filtro = true;
                this.filter.pageIndex = 1;
                this.setFiltros();//task[1873]
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {

                if (this.filter.telefoneNumero) this.filter.telefoneNumero = this.filter.telefoneNumero.replace(/\D+/g, '');
                if (this.filter.celularNumero) this.filter.celularNumero = this.filter.celularNumero.replace(/\D+/g, '');
                if (this.filter.cpf) this.filter.cpf = this.filter.cpf.replace(/\D+/g, '');

                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    //console.log("dataaa",data)
                    //console.log("eeeeentrei")
                    //console.log("end point ",this.resources.filter+" filtros ",this.filter);
                    if (data.summary) this.result.total = data.summary.total;

                    data.dataList = data.dataList.map(item => {
                        if (item.collectionColaboradorEscola)
                            item.collectionColaboradorEscola = item.collectionColaboradorEscola
                                .sort((a, b) => { return a.escola.nomeEscola > b.escola.nomeEscola });
                        return item;
                    });

                    this.result.items = data.dataList;
                    
                    localStorage.resultBuscaRelatorios = JSON.stringify(this.result.items);

                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            //task[1873]
            setFiltros: function () {
                localStorage.filtrosRelatorio = JSON.stringify(this.filter);
            },
            getResultadoBusca: function () {                
                if (localStorage.resultBuscaRelatorios) {
                    this.result.items = JSON.parse(localStorage.resultBuscaRelatorios);
                }
                
                //this.filtro = true;
            },
            getFiltros: function () {
                //console.log("valores gravados em cache: "+localStorage.filtros);
                if (localStorage.filtrosRelatorio) {
                    this.filter = JSON.parse(localStorage.filtrosRelatorio);
                    this.municipioPorEstado = false;                   
                    //setTimeout(() => { this.municipioPorEstado = false;}, 1000);
                    //console.log("valores: ",this.filter);
                }
            },
            //fim task
        },

        mounted() {
            this.escolaLogadaId = +auth.currentUser().tenant;
            this.ehAdministracaoNacional = this.escolaLogadaId == 276;

            //teste de estado dos campos
            this.getFiltros();

            this.getResultadoBusca();

        }

    };
</script>
<style scoped>
    /*task[1872]*/
    /*span[name=nmcargos]:hover {
        background-color: #ffd800;
        font-weight: bold;
    }*/
    span[name=nmescolas]:hover {
        background-color: #ffd800;
        font-weight: bold;
    }

    .destaca {
        font-weight: bold;
        background-color: #ffd800;
    }
</style>